<template>
  <div>
    <Divider content-position="left">邀请数据</Divider>
    <Field
      label="手机号"
      :model-value="inviteData.phone"
      readonly
      label-width="4.4em"
    />
    <Field
      label="总数量"
      :model-value="inviteData.Total"
      readonly
      label-width="4.4em"
    />
    <Field
      label="总提成"
      :model-value="inviteData.cash"
      readonly
      label-width="4.4em"
    />
    <Field
      label="可提余额"
      :model-value="inviteData.cashAvailable"
      readonly
      label-width="4.4em"
    />
    <Field
      label="邀请码"
      :model-value="inviteData.inviteCode"
      readonly
      label-width="4.4em"
    />
    <Cell title="更改余额" style="align-items: center">
      <template #value>
        <div style="display: flex">
          <Button
            size="small"
            type="warning"
            style="margin-right: 5px"
            @click="empty"
            >全清</Button
          >
          <Stepper
            v-model="setpperValue"
            step="0.08"
            :min="-inviteData.cashAvailable"
            :decimal-length="2"
            button-size="32px"
            input-width="40px"
          />
        </div>
      </template>
    </Cell>
    <Field>
      <template #input>
        <Button color="#292827" block round size="small" @click="changeBalance"
          >更改余额</Button
        >
      </template>
    </Field>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Field, Divider, Cell, Stepper, Button, Notify } from "vant";
import { inviteService } from "@/service/inviteService";
import { useInvite } from "@/composables/useInvite";
const { inviteData } = useInvite();
const setpperValue = ref(0);

const empty = () => {
  setpperValue.value = -inviteData.value.cashAvailable;
};

const changeBalance = () => {
  if (inviteData.value.phone == "NULL") {
    Notify("请先查询大笨蛋~");
    return;
  }
  let AuthorizationCode = sessionStorage.getItem("AuthorizationCode");
  inviteService
    .modifyCashAvailable(
      inviteData.value.phone,
      setpperValue.value.toString(),
      AuthorizationCode
    )
    .then((res) => {
      if (res["state"] == "success") {
        inviteData.value.cashAvailable = res["result"];
        Notify({ type: "success", message: "查询成功" });
      } else {
        Notify(res["result"]);
      }
    })
    .catch((err) => Notify(err["result"]));
};
</script>
<style></style>
